/**
 * Lot 2bis (Franck, 15/10/2026) : demandes des signataires - transmettre la
 * signature à une autre personne, ou signer sous le nom vérifié par la pièce
 * d'identité. La signature attend la réponse du client ; accepter applique
 * la demande, refuser la laisse sans effet. Qui et quand vont au Journal de
 * preuve, et le signataire est prévenu par e-mail.
 */
import { useState } from "react";

import { api, type DemandeSignataire } from "../api";
import { Erreur, date } from "./ui";

const STATUTS = {
  en_attente: { texte: "En attente de votre réponse", classe: "pill--pending" },
  acceptee: { texte: "Acceptée", classe: "pill--ok" },
  refusee: { texte: "Refusée", classe: "pill--muted" },
} as const;

const TYPES = { transmission: "Transmission de la signature", nom: "Correction du nom" } as const;

export function DemandesSignataires({ demandes, envelopeId, avecTitre, onDecide }: {
  demandes: DemandeSignataire[];
  /** Fiche de l'enveloppe : son id ; « À traiter » : celui de chaque demande. */
  envelopeId?: string;
  avecTitre?: boolean;
  onDecide: () => void;
}) {
  const [enCours, setEnCours] = useState<string | null>(null);
  const [erreur, setErreur] = useState<unknown>(null);

  const decider = async (d: DemandeSignataire, accepte: boolean) => {
    setEnCours(d.id);
    setErreur(null);
    try {
      await api.deciderDemande(envelopeId ?? d.envelope_id ?? "", d.id, accepte);
      onDecide();
    } catch (e) {
      setErreur(e);
    } finally {
      setEnCours(null);
    }
  };

  return (
    <>
      <Erreur erreur={erreur} />
      <ul className="demandes">
        {demandes.map((d) => {
          const st = STATUTS[d.statut ?? "en_attente"];
          const attente = (d.statut ?? "en_attente") === "en_attente";
          return (
            <li key={d.id} className={attente ? "demande demande--attente" : "demande"}>
              <div className="demande__texte">
                <p className="demande__type">
                  {TYPES[d.type]}
                  {avecTitre && d.title && <span className="muted"> · {d.title}</span>}
                </p>
                <p className="demande__resume">{d.resume.charAt(0).toUpperCase() + d.resume.slice(1)}</p>
                <p className="muted demande__meta">
                  Demandée par {d.demandee_par} le {date(d.demandee_le, true)}
                  {!attente && d.decidee_le && <> · {st.texte.toLowerCase()} le {date(d.decidee_le, true)}
                    {d.decidee_par && <> par {d.decidee_par}</>}</>}
                </p>
              </div>
              {attente ? (
                <div className="demande__actions">
                  <button type="button" className="btn btn--danger" disabled={enCours !== null}
                          onClick={() => void decider(d, false)}>Refuser</button>
                  <button type="button" className="btn btn--primary" disabled={enCours !== null}
                          onClick={() => void decider(d, true)}>
                    {enCours === d.id ? "Envoi…" : "Accepter"}
                  </button>
                </div>
              ) : (
                <span className={`pill ${st.classe}`}>{st.texte}</span>
              )}
            </li>
          );
        })}
      </ul>
    </>
  );
}
